import React, { useState } from 'react';
import axios from 'axios';

const EditMatchForm = ({ match, onCancel, onUpdated }) => {
  const [form, setForm] = useState(match);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://backend.aubattle.com/api/matches/${match.id}`, form);
      alert("Match updated!");
      onUpdated();
      onCancel();
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Edit Match</h3>
      <input name="title" value={form.title} onChange={handleChange} placeholder="Title" required /><br />
      <input name="entry_fee" value={form.entry_fee} onChange={handleChange} placeholder="Entry Fee" required /><br />
      <input name="max_players" value={form.max_players} onChange={handleChange} placeholder="Max Players" required /><br />
      <input name="room_id" value={form.room_id} onChange={handleChange} placeholder="Room ID" /><br />
      <input name="room_password" value={form.room_password} onChange={handleChange} placeholder="Room Password" /><br />
      <button type="submit">Update</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default EditMatchForm;
